var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1421_1024",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7162 0.120117H0V23.8363H23.7162V0.120117Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1421_1024)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3752 11.9777C13.3752 15.697 10.3807 18.7122 6.68665 18.7122C2.99263 18.7122 -0.00195312 15.697 -0.00195312 11.9777C-0.00195312 8.25831 2.99263 5.24316 6.68665 5.24316C10.3806 5.24316 13.3752 8.25831 13.3752 11.9777ZM20.7128 11.9777C20.7128 15.4788 19.2155 18.317 17.3685 18.317C15.5216 18.317 14.0242 15.4788 14.0242 11.9777C14.0242 8.47652 15.5216 5.63832 17.3685 5.63832C19.2155 5.63832 20.7128 8.47652 20.7128 11.9777ZM23.7142 11.9777C23.7142 15.1145 23.1876 17.6574 22.538 17.6574C21.8883 17.6574 21.3618 15.1145 21.3618 11.9777C21.3618 8.84079 21.8883 6.29788 22.538 6.29788C23.1876 6.29788 23.7142 8.84079 23.7142 11.9777Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoticon);
export default __webpack_public_path__ + "static/media/doticon.9cabdf1b56c131e9a3a8b148841f7492.svg";
export { ForwardRef as ReactComponent };